window.addEventListener("load", (event) => {
	//
	// js pour l'ouverture du panel de gestion des cookies
	//
	let cookiesLink = document.querySelector('a.open');
	cookiesLink && cookiesLink.addEventListener('click', function(event) {
		event.preventDefault();
		tarteaucitron.userInterface.openPanel();
	});


	//
    // js pour la réécriture des emails
    //
    function deObfuscateEmail(mail) {
        mail.href = mail.href.replace(new RegExp("%7BAT%7D", 'g'), '@').replace(new RegExp("%7BDOT%7D", 'g'), '.');

        let mailSpan = mail.querySelector("span");
        mailSpan.innerText = mailSpan.innerText.replace(new RegExp("{AT}", 'g'), '@').replace(new RegExp("{DOT}", 'g'), '.');

        mail.classList.remove('opacity-0');
    }

    document.querySelectorAll('.obfuscated').forEach((mail) => {
        deObfuscateEmail(mail);
    });
});